export default "__VITE_ASSET__5wglw$Va__"